import {
  ContentPopperProps,
  Flyout,
  WebCouponBannerProps,
  WebCouponBanner as WebCouponBannerView,
} from '@aboutyou/ui-components';
import React from 'react';
import {CouponInfoContentPopper} from '../Coupons/CouponInfoContentPopper/CouponInfoContentPopper';
import {useCouponInfoContentPopperStateManager} from '../Coupons/CouponInfoContentPopper/useCouponInfoContentPopperStateManager';
import bannerBackground from '../Coupons/assets/bannerBackground.svg';
import {useWebCouponDeviceImage} from './utils/useWebCouponDeviceImage';

export const WEB_COUPON_DISCOUNT = '-5%';

export interface WebCouponTranslations {
  closeButton: string;
  ctaText?: string;
  modalBadgeText: string;
  modalContent: string;
  modalTitle: string;
  text: string;
}

export const WebCouponBanner = ({
  className,
  deviceSize,
  translations,
  textSize,
  CTALink,
  showCTAasText,
  onCTAClick,
  showInfoIcon = true,
  infoIconSize,
  qrCodeImage,
  storeBadgesPosition,
  StoreBadgesComponent,
  WebCouponBannerInfoLayoutComponent = Flyout,
  ref,
}: Omit<WebCouponBannerProps, 'deviceImage' | 'text'> & {
  WebCouponBannerInfoLayoutComponent?: ContentPopperProps['LayoutComponent'];
  translations: WebCouponTranslations;
} & {ref?: React.Ref<HTMLDivElement>}) => {
  const {open} = useCouponInfoContentPopperStateManager();
  const deviceImage = useWebCouponDeviceImage();

  const onInfoIconClick = () => {
    open();
  };

  return (
    <>
      <WebCouponBannerView
        ref={ref}
        className={className}
        deviceImage={deviceImage}
        deviceSize={deviceSize}
        text={translations.text}
        textSize={textSize}
        ctaText={translations.ctaText}
        showCTAasText={showCTAasText}
        CTALink={CTALink}
        onCTAClick={onCTAClick}
        showInfoIcon={showInfoIcon}
        infoIconSize={infoIconSize}
        onInfoIconClick={onInfoIconClick}
        qrCodeImage={qrCodeImage}
        storeBadgesPosition={storeBadgesPosition}
        StoreBadgesComponent={StoreBadgesComponent}
        bannerBackgroundSvg={bannerBackground}
      />

      {showInfoIcon && (
        <CouponInfoContentPopper
          LayoutComponent={WebCouponBannerInfoLayoutComponent}
          translations={{
            badgeText: translations.modalBadgeText,
            title: translations.modalTitle,
            content: translations.modalContent,
            closeButtonText: translations.closeButton,
          }}
          data-testid="webCouponBannerInfoComponent"
        />
      )}
    </>
  );
};
